var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.739V20.2615C6.75245 20.3933 6.78962 20.5222 6.85776 20.6351C6.9259 20.748 7.0226 20.841 7.13812 20.9046C7.25364 20.9682 7.38388 21.0002 7.51572 20.9974C7.64756 20.9946 7.77634 20.9571 7.88906 20.8887L21.3966 12.6274C21.5045 12.5621 21.5937 12.4701 21.6556 12.3602C21.7175 12.2504 21.7501 12.1264 21.7501 12.0003C21.7501 11.8741 21.7175 11.7501 21.6556 11.6403C21.5937 11.5304 21.5045 11.4384 21.3966 11.3731L7.88906 3.11181C7.77634 3.04338 7.64756 3.00588 7.51572 3.0031C7.38388 3.00031 7.25364 3.03233 7.13812 3.09594C7.0226 3.15954 6.9259 3.25248 6.85776 3.36538C6.78962 3.47828 6.75245 3.60715 6.75 3.739Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.278c2cb0713eb6a39ee6f87c214446ce.svg";
export { ForwardRef as ReactComponent };